import { requestWithPromise } from '..'
import { GET } from '../apiHelper'

export const getAllLanguages = user => {
  return requestWithPromise(
    '/api/languages',
    GET,
    null,
    user
  ).then(json => {
    return json?.data ?? []
  })
}
